"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CosmostationWCModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var modal_1 = require("./modal");
var react_dom_1 = __importDefault(require("react-dom"));
var CosmostationWCModal = /** @class */ (function () {
    function CosmostationWCModal() {
    }
    CosmostationWCModal.prototype.open = function (uri, cb) {
        var _this = this;
        var wrapper = document.createElement("div");
        wrapper.setAttribute("id", "cosmostation-wc-modal");
        document.body.appendChild(wrapper);
        react_dom_1.default.render((0, jsx_runtime_1.jsx)(modal_1.Modal, { uri: uri, close: function () {
                _this.close();
                cb();
            } }), wrapper);
    };
    CosmostationWCModal.prototype.close = function () {
        var wrapper = document.getElementById("cosmostation-wc-modal");
        if (wrapper) {
            document.body.removeChild(wrapper);
        }
    };
    return CosmostationWCModal;
}());
exports.CosmostationWCModal = CosmostationWCModal;
exports.default = CosmostationWCModal;
